'use client';

import { useStore } from 'zustand';

import { useFeatureFlag } from '@/feature-flags/hooks/use-feature-flag.hook';
import { authStore } from '@/store/auth.store';

export interface UseOpenPaymentsAvailabilityResult {
  isAvailable: boolean;
  isResolved: boolean;
}

export function useOpenPaymentsAvailability(): UseOpenPaymentsAvailabilityResult {
  const { value: enabled, loading } = useFeatureFlag('newCart');
  const authStatus = useStore(authStore, (state) => state.authStatus);
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);

  const isResolved = !loading && authStatus !== 'loading';

  return { isResolved, isAvailable: isResolved && enabled && isLoggedIn };
}
